<app-nav></app-nav>
<main class="page page-apply-cart">
  <div class="container content-section mt-lg-5">
    <form action="#" class="apply-form">
      <div class="row mt-5">
        <div class="col">
          <fieldset>
            <legend class="section-header-legend bg-blue-primary text-white" translate>
              PAYMENT REVIEW
            </legend>
            <div class="form-control-wrapper">
              <div class="table-responsive">
                <table class="table table-striped">
                  <thead>
                    <th class="text-center" translate>NO.</th>
                    <th style="width: 100px" class="text-center" translate>
                      PHOTO
                    </th>
                    <th style="width: 120px" class="text-center" translate>
                      PASSPORT
                    </th>
                    <th *ngIf="proofileCol" style="width: 120px" class="text-center" translate>
                      <span>PROOF&nbsp;OF&nbsp;LAOTIAN</span>
                    </th>
                    <th translate>DETAILS</th>
                    <th style="width: 90px" class="text-center" translate>
                      FEE
                    </th>
                  </thead>
                  <tbody>
                    <tr *ngFor="let item of mDataArrayPerson; let i = index">
                      <td class="text-center">{{ i + 1 }}</td>
                      <td class="text-center">
                        <div>
                          <img (click)="openPhoto(i)" width="100px" [src]="item.photo_name" alt="..."
                            class="img-fluid img-thumbnail photo mouse_pointer" />
                        </div>
                      </td>

                      <td class="text-center">
                        <div>
                          <img (click)="openPassport(i)" width="100px" [src]="item.passport_name" alt="..."
                            class="img-fluid img-thumbnail passport mouse_pointer" />
                        </div>
                      </td>
                      <td class="text-center" *ngIf="proofileCol">
                        <div>
                          <img (click)="openPassport(i)" width="100px" [src]="item.passport_name" alt="..."
                            class="img-fluid img-thumbnail passport mouse_pointer" />
                        </div>
                      </td>

                      <td>
                        <div style="width: 350px">
                          <div class="text-primary font-weight-bold h5">
                            {{ item.last_name }} {{ item.first_name }}
                          </div>
                          <ul class="pl-0">
                            <li class="row pl-0">
                              <div class="col colon-after-label">
                                APPLICATION ID
                              </div>
                              <div class="col">
                                {{ item.application_id }}
                              </div>
                            </li>
                            <li class="row pl-0">
                              <div class="col colon-after-label" translate>
                                {{
                                app.SelectedLang == "en" ? "GENDER" : "性别"
                                }}
                              </div>
                              <div class="col">
                                {{ item.gender | titlecase }}
                              </div>
                            </li>
                            <li class="row pl-0">
                              <div class="col colon-after-label" translate>
                                {{
                                app.SelectedLang == "en"
                                ? "DATE OF BIRTH"
                                : "出生日期"
                                }}
                              </div>
                              <div class="col">{{ item.dob }}</div>
                            </li>
                            <li class="row pl-0">
                              <div class="col colon-after-label" translate>
                                {{
                                app.SelectedLang == "en"
                                ? "TELEPHONE"
                                : "电话号码"
                                }}
                              </div>
                              <div class="col">{{ item.telephone }}</div>
                            </li>
                            <li class="row pl-0">
                              <div class="col colon-after-label" translate>
                                {{
                                app.SelectedLang == "en"
                                ? "PASSPORT NO."
                                : "护照号码"
                                }}
                              </div>
                              <div class="col">{{ item.passport_number }}</div>
                            </li>
                            <li class="row pl-0">
                              <div class="col colon-after-label" translate>
                                {{
                                app.SelectedLang == "en"
                                ? "DATE OF ISSUE"
                                : "签发日期"
                                }}
                              </div>
                              <div class="col">{{ item.issue_date }}</div>
                            </li>
                            <li class="row pl-0">
                              <div class="col colon-after-label" translate>
                                {{
                                app.SelectedLang == "en"
                                ? "EXPIRY DATE"
                                : "到期日"
                                }}
                              </div>
                              <div class="col">{{ item.expired_date }}</div>
                            </li>
                            <!-- <li class="row pl-0">
                              <div class="col colon-after-label" translate>
                                {{
                                app.SelectedLang == "en"
                                ? "VISA TYPE"
                                : "签证类型"
                                }}
                              </div>
                              <div class="col">{{ item.visa_type_name }}</div>
                            </li> -->
                            <li *ngIf="item.race == 304" class="row pl-0">
                              <div class="col colon-after-label" translate>
                                FAMILY SIDE
                              </div>
                              <div class="col">
                                {{ item.family_side | uppercase }}
                              </div>
                            </li>
                            <li *ngIf="item.race == 304" class="row pl-0">
                              <div class="col colon-after-label" translate>
                                MEMBER
                              </div>
                              <div class="col">
                                {{ item.family_member_names }}
                              </div>
                            </li>
                            <li *ngIf="item.race == 304" class="row pl-0">
                              <div class="col colon-after-label" translate>
                                RELATIONSHIP
                              </div>
                              <div class="col">
                                {{ item.family_relation }}
                              </div>
                            </li>
                          </ul>
                        </div>
                      </td>
                      <td class="text-center">
                        <div class="text-primary h5">${{ item.price }}</div>
                      </td>
                    </tr>
                    <tr>
                      <td [colSpan]="proofileCol ? 5 : 4" class="text-right text-secondary">
                        <h3 translate>Total</h3>
                      </td>
                      <td>
                        <h3 class="font-weight-bold text-secondary">
                          ${{ total }}
                        </h3>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <footer>
                <div class="row">
                  <div class="col col-lg-4 mt-top col-md-12 col-sm-12 mr-auto">
                    <div class="d-flex flex-column flex-lg-row justify-content-between mt-2">
                      <button class="btn btn-secondary btn-icon d-inline-flex" id="back-to-cart" routerLink="/cart"
                        (click)="backToCart($event)">
                        <i class="fa fa-arrow-left" id="back-to-cart"></i>
                        <span class="ml-2 text-uppercase" translate id="back-to-cart">Back&nbsp;to&nbsp;cart</span>
                      </button>
                    </div>
                  </div>
                  <div *ngIf="isEmptyCart == false && mDataArrayPerson"
                    class="col col-lg-4 mt-top col-md-12 col-sm-12 ml-auto">
                    <app-paynow [invoiceUuId]="invoice_uuid" payFrom="cart" (mDataArrayPerson)="onGetPersonInfo($event)"></app-paynow>
                  </div>
                </div>
              </footer>
            </div>
          </fieldset>
        </div>
      </div>

      <footer class="row text-center mt-5"></footer>
    </form>
  </div>
</main>
<app-footer></app-footer>
